/* ============================================================
   DiVAS — keresés (lightbox + találati oldal)

   Miért saját index: a Shopify storefront keresője token-alapú, és ezen a bolton nem
   hozza a befejezetlen szavakat („forg" -> Forgószék). Az `options[prefix]=last` sem
   segített, a predictive API pedig típusonként max 10 találatot ad, ami találati
   oldalnak kevés. Ezért a `divas-kereso-index.json`-ból keresünk: a TERMÉK NEVÉBEN,
   részszóra, ékezet- és kisbetű-függetlenül. Egy index szolgálja ki a lightboxot és a
   találati oldalt, tehát a kettő ugyanazt adja.

   Az indexet a Shopify/kereso_index.py állítja elő. Terméknév- vagy árváltozás után
   újra kell futtatni.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-dsearch]');
  var page = document.querySelector('[data-search-page]');
  if (!root && !page) return;

  var INDEX_URL = (root && root.getAttribute('data-index')) ||
                  (page && page.getAttribute('data-index'));
  var SEARCH_URL = (root && root.getAttribute('data-search-url')) ||
                   (page && page.getAttribute('data-search-url')) || '/search';
  var MIN = 2;
  var LIGHTBOX_LIMIT = 6;
  var PAGE_STEP = 24;

  /* ---------- index ---------- */
  var indexPromise = null;

  function fold(s) {
    s = String(s == null ? '' : s).toLowerCase();
    return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = fetch(INDEX_URL)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (d) {
        // a hajtogatott nevet egyszer számoljuk ki, utána minden keresés gyors
        for (var i = 0; i < d.p.length; i++) d.p[i].push(fold(d.p[i][0]));
        var c = d.c || [];
        for (var j = 0; j < c.length; j++) c[j].push(fold(c[j][0]));
        return d;
      });
    return indexPromise;
  }

  /* Minden beírt szónak szerepelnie kell a névben (részszóként is). */
  function find(data, term) {
    var words = fold(term).split(/\s+/).filter(Boolean);
    if (!words.length) return [];
    var out = [], rows = data.p, FOLDED = 7;
    for (var i = 0; i < rows.length; i++) {
      var t = rows[i][FOLDED], ok = true;
      for (var w = 0; w < words.length; w++) {
        if (t.indexOf(words[w]) === -1) { ok = false; break; }
      }
      if (ok) out.push(rows[i]);
    }
    // a névelején egyező találat előre
    var first = words[0];
    out.sort(function (a, b) {
      var ai = a[FOLDED].indexOf(first), bi = b[FOLDED].indexOf(first);
      if (ai !== bi) return ai - bi;
      return a[0].localeCompare(b[0], 'hu');
    });
    return out;
  }

  /* ---------- közös segédek ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function ft(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  }
  function imgUrl(data, suffix, w) {
    if (!suffix) return '';
    var u = /^https?:/.test(suffix) ? suffix : data.prefix + suffix;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  var FEAT_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">' +
    '<path d="M3 7 12 3l9 4-9 4-9-4Z"/><path d="M3 7v8l9 4 9-4V7"/><path d="M12 11v8"/></svg>';

  /* ---------- termékkártya (a divas-product-card.liquid mása) ---------- */
  function card(data, r) {
    var title = r[0], handle = r[1], price = r[2], img = r[3], b1 = r[4], b2 = r[5], cols = r[6];
    var url = '/products/' + handle;
    var pic = img
      ? '<div class="ph"><img src="' + esc(imgUrl(data, img, 800)) + '" alt="" loading="lazy" width="800" height="600"></div>'
      : '<div class="ph"></div>';
    var sw = (cols && cols.length)
      ? '<div class="swatches">' + cols.map(function (c) {
          return '<span class="swatch" style="background:' + esc(c) + '"></span>';
        }).join('') + '</div>'
      : '';
    var pr = price === 0
      ? '<div class="col-card__price col-card__price--quote">Kérj ajánlatot</div>'
      : '<div class="col-card__price">' + ft(price) + '</div>';

    return '<article class="col-card">' +
      '<a href="' + url + '" aria-label="' + esc(title) + '">' + pic + '</a>' +
      '<div class="col-card__body">' +
        '<a href="' + url + '"><h3 class="col-card__title">' + esc(title) + '</h3></a>' +
        sw + pr +
        '<div class="col-feat">' + FEAT_ICON + '<span>' + esc(b1) + '</span></div>' +
        '<div class="col-feat">' + FEAT_ICON + '<span>' + esc(b2) + '</span></div>' +
        '<a href="' + url + '" class="link-arrow">Megnézem' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 17 17 7M9 7h8v8"/></svg>' +
        '</a>' +
      '</div></article>';
  }

  /* ============================================================
     TALÁLATI OLDAL
     ============================================================ */
  if (page) {
    var grid    = page.querySelector('[data-search-grid]');
    var count   = page.querySelector('[data-search-count]');
    var more    = page.querySelector('[data-search-more]');
    var noHit   = page.querySelector('[data-search-nohit]');
    var intro   = page.querySelector('[data-search-intro]');
    var fallback= page.querySelector('[data-search-fallback]');
    var form    = page.querySelector('[data-search-form]');

    var params = new URLSearchParams(window.location.search);
    var term = (params.get('q') || '').trim();
    var shown = 0, hits = [], idx = null;

    if (form) {
      var fin = form.querySelector('input[type="search"]');
      if (fin) fin.value = term;
    }

    function renderMore() {
      var slice = hits.slice(shown, shown + PAGE_STEP);
      grid.insertAdjacentHTML('beforeend', slice.map(function (r) { return card(idx, r); }).join(''));
      shown += slice.length;
      more.hidden = shown >= hits.length;
      if (!more.hidden) {
        more.textContent = 'További termékek (' + (hits.length - shown) + ')';
      }
    }

    if (term) {
      // a szerver által rendereltet leváltjuk, amint kész az index
      loadIndex().then(function (data) {
        idx = data;
        hits = find(data, term);
        if (fallback) fallback.remove();
        if (intro) intro.hidden = true;
        grid.innerHTML = '';
        shown = 0;

        if (!hits.length) {
          count.innerHTML = 'Nincs találat erre: <strong>„' + esc(term) + '"</strong>';
          noHit.hidden = false;
          more.hidden = true;
          return;
        }
        count.innerHTML = '<strong>' + hits.length + '</strong> termék erre: <strong>„' + esc(term) + '"</strong>';
        noHit.hidden = true;
        renderMore();
      }).catch(function () {
        // ha az index nem tölthető, marad a szerver által rendered lista
        if (fallback) fallback.hidden = false;
      });

      more.addEventListener('click', renderMore);
    }
  }

  /* ============================================================
     LIGHTBOX
     ============================================================ */
  if (!root) return;

  var panel   = root.querySelector('.dsearch__panel');
  var input   = root.querySelector('[data-dsearch-input]');
  var results = root.querySelector('[data-dsearch-results]');
  var lintro  = root.querySelector('[data-dsearch-intro]');
  var empty   = root.querySelector('[data-dsearch-empty]');
  var allLink = root.querySelector('[data-dsearch-all]');
  var clearBtn= root.querySelector('[data-dsearch-clear]');
  var lastQuery = '', lastOpener = null, lidx = null;

  function open(opener) {
    lastOpener = opener || null;
    root.hidden = false;
    document.body.classList.add('dsearch-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    setTimeout(function () { input.focus(); input.select(); }, 60);
    loadIndex();   // előtöltjük, hogy az első gépelés már azonnali legyen
  }

  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('dsearch-open');
    setTimeout(function () { root.hidden = true; }, 220);
    if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
  }

  function hitRow(data, r) {
    var img = r[3]
      ? '<img src="' + esc(imgUrl(data, r[3], 112)) + '" alt="" loading="lazy" width="56" height="56">'
      : '<span class="dsearch__ph"></span>';
    var price = r[2] === 0
      ? '<span class="dsearch__hit-price dsearch__hit-price--quote">Kérj ajánlatot</span>'
      : '<span class="dsearch__hit-price">' + ft(r[2]) + '</span>';
    return '<a class="dsearch__hit" href="/products/' + r[1] + '">' + img +
      '<span class="dsearch__hit-main">' +
        '<span class="dsearch__hit-title">' + esc(r[0]) + '</span>' +
        '<span class="dsearch__hit-meta">' + esc(r[4]) + '</span>' +
      '</span>' + price + '</a>';
  }

  function resetLightbox() {
    results.hidden = true; results.innerHTML = '';
    empty.hidden = true; allLink.hidden = true; lintro.hidden = false;
    clearBtn.hidden = true;
  }

  /* a lightboxban a termékek mellett kategóriát is ajánlunk */
  function findCollections(data, term) {
    var words = fold(term).split(/\s+/).filter(Boolean);
    var c = data.c || [], out = [];
    for (var i = 0; i < c.length; i++) {
      var ok = true;
      for (var w = 0; w < words.length; w++) {
        if (c[i][3].indexOf(words[w]) === -1) { ok = false; break; }
      }
      if (ok) out.push(c[i]);
    }
    return out.slice(0, 4);
  }

  function runLightbox(q) {
    lintro.hidden = true;
    if (!results.innerHTML) {
      results.hidden = false;
      results.innerHTML = '<div class="dsearch__spinner"></div>';
    }
    loadIndex().then(function (data) {
      if (input.value.trim() !== q) return;   // közben tovább gépelt
      lidx = data;
      var hits = find(data, q);
      if (!hits.length && !findCollections(data, q).length) {
        results.hidden = true; results.innerHTML = '';
        empty.hidden = false; allLink.hidden = true;
        return;
      }
      var html = '';
      if (hits.length) {
        html += '<div class="dsearch__group"><p class="dsearch__label">Termékek</p>' +
          hits.slice(0, LIGHTBOX_LIMIT).map(function (r) { return hitRow(data, r); }).join('') + '</div>';
      }
      var cols = findCollections(data, q);
      if (cols.length) {
        html += '<div class="dsearch__group"><p class="dsearch__label">Kategóriák</p>' +
          cols.map(function (c) {
            return '<a class="dsearch__hit" href="/collections/' + c[1] + '">' +
              '<span class="dsearch__ph"></span><span class="dsearch__hit-main">' +
              '<span class="dsearch__hit-title">' + esc(c[0]) + '</span>' +
              '<span class="dsearch__hit-meta">' + c[2] + ' termék</span></span></a>';
          }).join('') + '</div>';
      }
      results.innerHTML = html;
      results.hidden = false;
      empty.hidden = true;
      if (hits.length) {
        allLink.href = SEARCH_URL + '?q=' + encodeURIComponent(q);
        allLink.textContent = '';
        allLink.insertAdjacentHTML('afterbegin',
          'Mind a ' + hits.length + ' találat megtekintése' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>');
      }
      allLink.hidden = !hits.length;
    }).catch(function () {
      results.hidden = true; results.innerHTML = '';
      allLink.href = SEARCH_URL + '?q=' + encodeURIComponent(q);
      allLink.hidden = false;
    });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearBtn.hidden = !q;
    if (q === lastQuery) return;
    lastQuery = q;
    if (q.length < MIN) { resetLightbox(); return; }
    runLightbox(q);
  });

  clearBtn.addEventListener('click', function () {
    input.value = ''; lastQuery = ''; resetLightbox(); input.focus();
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var hits = results.querySelectorAll('.dsearch__hit');
      if (!hits.length) return;
      e.preventDefault();
      var cur = -1;
      for (var i = 0; i < hits.length; i++) {
        if (hits[i].classList.contains('is-active')) { cur = i; hits[i].classList.remove('is-active'); }
      }
      var next = e.key === 'ArrowDown' ? cur + 1 : cur - 1;
      if (next < 0) next = hits.length - 1;
      if (next >= hits.length) next = 0;
      hits[next].classList.add('is-active');
      hits[next].scrollIntoView({ block: 'nearest' });
      return;
    }

    if (e.key === 'Enter') {
      var active = results.querySelector('.dsearch__hit.is-active');
      if (active) { e.preventDefault(); window.location.href = active.href; }
    }

    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([hidden]),input,select,textarea');
      var list = [];
      for (var j = 0; j < f.length; j++) { if (f[j].offsetParent !== null) list.push(f[j]); }
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-dsearch-open]');
    if (opener) { e.preventDefault(); open(opener); return; }
    if (e.target.closest && e.target.closest('[data-dsearch-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!root.hidden) return;
    var t = e.target, tag = t && t.tagName;
    var ir = tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable);
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(null); return; }
    if (e.key === '/' && !ir && !e.metaKey && !e.ctrlKey && !e.altKey) { e.preventDefault(); open(null); }
  });
})();
